import { $api } from '@service/RequestService';
import { colorPieChart } from '@utils/constants/colorPieChart';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { NumericArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { generateBrightColor } from '../helpers';
import { ChartModel, ChartResModel, WidgetBodyModel } from '../models';

export function usePieChartWidget({ id, body }: { body: WidgetBodyModel; id: number }) {
  const {
    i18n: { language }
  } = useTranslation();

  const [query] = useQueryParams({
    startDate: StringParam,
    finishDate: StringParam,
    responsibleByIds: NumericArrayParam
  });

  const parseQuery = queryString.stringify(query);

  const { data, ...arg } = useQuery<ChartResModel, unknown, ChartModel>(
    ['dashboard-v2-chart', id, parseQuery],
    async () => {
      const { data } = await $api.post(`/v1/dashboard/widget/chart/v2${parseQuery ? `?${parseQuery}` : ''}`, body);

      return { ...data?.data };
    },
    {
      enabled: !!body?.dashboardId,
      // @ts-expect-error
      select: ({ filterWithDate, filter }) => ({
        filter: {
          ...filter,
          leadList: filter?.leadList?.map((e, i) => {
            const label = e?.[language as keyof typeof e] || e?.field;

            return {
              label,
              item: e,
              value: body?.amountType ? e?.amount : e?.count,
              id: `${e?.[language as keyof typeof e] || e?.field}-${i}`,
              color: i > 8 ? generateBrightColor(label) : colorPieChart[i]
            };
          })
        },
        filterWithDate: {
          ...filterWithDate,
          leadList: filterWithDate?.leadList?.map((e, i) => {
            const label = e?.[language as keyof typeof e] || e?.field;

            return {
              label,
              item: e,
              value: body?.amountType ? e?.amount : e?.count,
              id: `${e?.[language as keyof typeof e] || e?.field}-${i}`,
              color: i > 8 ? generateBrightColor(label) : colorPieChart[i]
            };
          })
        }
      })
    }
  );

  return { ...data, ...arg };
}
